










































import Vue from "vue";
import Challenge from "./components/Challenge.vue";
import Spinner from "./components/Spinner.vue";
import Welcome from "./components/Welcome.vue";
import CameraSelection from "./components/CameraSelection.vue";
import Result from "./components/Result.vue";
import Error from "./components/Error.vue";
import CloseButton from "./components/CloseButton.vue";
import CancelConfirmation from "./components/CancelConfirmation.vue";
import NoCameraPermission from "./components/NoCameraPermission.vue";
import { ChallengeDetails } from "@/js/RemoteStarter";
import { ChallengeProcessor } from "@/js/ChallengeProcessor";
import { RemoteVerifier } from "@/js/RemoteVerifier";
import { Utils } from "@/js/Utils";
import { EventEmitter } from "@/js/EventEmitter";
import ErrorManager from "@/js/ErrorManager";

Utils.loadConfig();
Utils.configureLogger();

export default Vue.extend({
  name: "App",
  components: {
    Welcome,
    CameraSelection,
    Challenge,
    Spinner,
    Result,
    Error,
    CloseButton,
    CancelConfirmation,
    NoCameraPermission
  },
  data() {
    return {
      challengeDetails: {} as ChallengeDetails,
      success: false,
      step: 5,
      mediaStreamReady: false,
      errorMessage: "",
      showCancelConfirmation: false,
      logs: "",
      cameraErrorType: ""
    };
  },
  methods: {
    onPermissionDeny(cameraError: boolean) {
      this.step = 6;
      this.cameraErrorType = cameraError ? "error" : "denied";
    },
    onChallengeDetails(challengeDetails: ChallengeDetails): void {
      this.challengeDetails = challengeDetails;
      this.step = 2;
    },
    onLocalSuccess(remoteVerifier: RemoteVerifier): void {
      this.step = 3;

      const self = this;
      remoteVerifier.verify(
        function(success: boolean, logs: string) {
          self.success = success;
          self.logs = logs;
          self.step = 4;
          if (success) {
            EventEmitter.success(self.challengeDetails.id);
          }
        },
        function(error: Error) {
          self.onError(error);
        }
      );
    },
    onLocalFail(): void {
      this.success = false;
      this.step = 4;
    },
    onRestart(): void {
      this.logs = "";
      this.step = 1;
    },
    onError(error: Error): void {
      this.errorMessage = error.name + ": " + error.message;
      this.step = -1;
    },
    cancelVerify(): void {
      this.showCancelConfirmation = true;
    },
    onCancelConfirmationGoBack(): void {
      this.showCancelConfirmation = false;
    },
    onCancelConfirmationConfirm(): void {
      EventEmitter.cancel();
      this.showCancelConfirmation = false;
      this.onRestart();
    },
    async onCameraSelected(cameraStrategy: string): Promise<void> {
      this.step = 1;
      const innerDialogElement = this.$refs.innerDialog as HTMLElement;
      const dialogClientWidth = innerDialogElement.clientWidth;
      const dialogClientHeight = innerDialogElement.clientHeight;
      try {
        await Utils.loadMediaStream(dialogClientWidth, dialogClientHeight, cameraStrategy);
        this.mediaStreamReady = true;
      } catch (e) {
        this.errorMessage = e;
        this.step = -1;
      }
    }
  },
  beforeMount: function() {
    ErrorManager.addGlobalErrorListener((e: any) => {
      this.step = -1;
      this.errorMessage = e.message;
    });
  },
  mounted: function() {
    ChallengeProcessor.loadModels();
    const remiUsername = this.$route.query.u;
    if (remiUsername) {
      Utils.setRemiUsername(remiUsername + "");
    }
    const remiUserId = this.$route.query.rid;
    if (remiUserId) {
      Utils.setRemiUserId(remiUserId + "");
    }
    const challengeType = this.$route.query.t || "faceup";
    if (challengeType) {
      Utils.setChallengeType(challengeType + "");
    }
  },
  errorCaptured: function(err: Error) {
    this.step = -1;
    this.errorMessage = err.message;
  }
});
